export var MINIMUM_VALUE = 1;
export var EVERY = 'every';
export var INTERVAL_SEPARATOR = '_';